import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import cancel from './cancel.js'
import close from './close.js'
import display from './display.js'

export default contract({
  cancel: array([
    cancel
  ]),
  close: array([
    close
  ]),
  display: array([
    display
  ]),
})
